/*
  Shared search defaults.

  MIN_DAYS_COUNT backs the "Waiting 1 year +" curated search. It is sent as
  minimumDaysAwaitingSponsorshipCount and must stay in sync with the copy on
  that control, which promises one year.
*/

export const MIN_DAYS_COUNT = 365;
